import { useMemo } from "react";
import { TemplateType } from "../components/CalculationTemplates/TemplateForm/TemplateFormActions";
import { TemplateFormState } from "./useTemplateForm";

function checkAttrValue(formState: TemplateFormState[TemplateType.AttrValue]) {
  const hasAttribute = formState.option && formState.option.value;
  const hasAction = formState.action && formState.action.value;
  const hasValue = formState.value;

  return !!(hasAttribute && hasAction && hasValue);
}

function checkAttrAttr(formState: TemplateFormState[TemplateType.AttrAttr]) {
  const hasAttributes = formState.option1 && formState.option1.text && formState.option2 && formState.option2.text;
  const hasAction = formState.action && formState.action.text;

  return !!(hasAttributes && hasAction);
}

function checkAttrGeometry(
  formState: TemplateFormState[TemplateType.Geometry] | TemplateFormState[TemplateType.Attribute],
) {
  return !!(formState.option && formState.option.value);
}

function checkCurrentTemplate(type: TemplateType, formState: TemplateFormState): boolean {
  switch (type) {
    case "attrValue":
      return checkAttrValue(formState[type]);
    case "attrAttr":
      return checkAttrAttr(formState[type]);
    case "geometry":
    case "attribute":
      return checkAttrGeometry(formState[type]);
    default:
      return false;
  }
}

export const useCheckTemplateForm = (type: TemplateType, formState: TemplateFormState) => {
  return useMemo(() => checkCurrentTemplate(type, formState), [type, formState]);
};
